import { FC, ReactNode } from 'react'

import { SxProps, TableCell, TableRow, Theme } from '@mui/material'

import { HeaderCell } from './HeaderCell'

export const HORIZONTAL_TABLE_CELL_TEST_ID = 'horizontal-table-cell' as const
export const HORIZONTAL_TABLE_ROW_TEST_ID = 'horizontal-table-row' as const

type Props = {
  testId?: string
  header: ReactNode
  values: ReactNode[]
  sx?: SxProps<Theme>
}

export const Row: FC<Props> = ({ testId, header, values, sx }) => {
  return (
    <TableRow data-testid={testId || HORIZONTAL_TABLE_ROW_TEST_ID}>
      <HeaderCell>{header}</HeaderCell>
      {values.map((value, index) => (
        <TableCell
          data-testid={HORIZONTAL_TABLE_CELL_TEST_ID}
          key={`table-cell-${index}`}
          sx={{
            minWidth: 150,
            ...sx
          }}
        >
          {value}
        </TableCell>
      ))}
    </TableRow>
  )
}
